module.exports = __webpack_public_path__ + "media/images/notfound_image-b8fb53f82bcade82ec05caaaf1d1f570.png";